import { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import Routes, { CreateAccountPageSteps } from 'config/routes';

import useSaveFrom from 'hooks/useSaveFrom';
import useAuthentication from 'domain/authentication/useAuthentication';
import SignUpFormValidator from 'domain/authentication/usecases/SignUpFormValidator';

const useCreateAccountPage = () => {
  const from = useSaveFrom('create_account_from');
  const { step } = useParams();
  const history = useHistory();
  const { isAuthenticated } = useAuthentication();

  const [form, setForm] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    passwordConfirmation: '',
  });

  const backRouter = (step) => {
    switch (step) {
      case CreateAccountPageSteps.firstName:
        history.push(from);
        break;

      case CreateAccountPageSteps.lastName:
        history.push(Routes.createAccount(CreateAccountPageSteps.firstName));
        break;

      case CreateAccountPageSteps.email:
        history.push(Routes.createAccount(CreateAccountPageSteps.lastName));
        break;

      case CreateAccountPageSteps.password:
        history.push(Routes.createAccount(CreateAccountPageSteps.email));
        break;

      case CreateAccountPageSteps.passwordConfirmation:
        history.push(Routes.createAccount(CreateAccountPageSteps.password));
        break;

      case CreateAccountPageSteps.request:
        history.push(
          Routes.createAccount(CreateAccountPageSteps.passwordConfirmation)
        );
        break;

      default:
        throw new Error('invalid step');
    }
  };

  const nextRouter = (step) => {
    switch (step) {
      case CreateAccountPageSteps.firstName:
        history.push(Routes.createAccount(CreateAccountPageSteps.lastName));
        break;

      case CreateAccountPageSteps.lastName:
        history.push(Routes.createAccount(CreateAccountPageSteps.email));
        break;

      case CreateAccountPageSteps.email:
        history.push(Routes.createAccount(CreateAccountPageSteps.password));
        break;

      case CreateAccountPageSteps.password:
        history.push(
          Routes.createAccount(CreateAccountPageSteps.passwordConfirmation)
        );
        break;

      case CreateAccountPageSteps.passwordConfirmation:
        history.push(Routes.createAccount(CreateAccountPageSteps.request));
        break;

      default:
        throw new Error('invalid step');
    }
  };

  const exitPage = () => history.replace(from);

  return {
    isAuthenticated,
    step,
    backRouter,
    nextRouter,
    form,
    setForm,
    formValidator: SignUpFormValidator(form),
    exitPage,
  };
};

export default useCreateAccountPage;
